module.exports = __webpack_public_path__ + "img/natural-english-conversation.8a76cddf.jpg";